import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {UserService} from "../../services/apiCalls/userService/user.service";
import {UtilService} from "../../services/utilService/util.service";
import {IResponse, transactionFilters, transactionProp} from "../../interfaces/iresponse";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SuperAdminService } from 'src/app/services/apiCalls/superAdminService/super-admin.service';
import { genderType } from 'src/app/users/enrol-riders/enrol-riders.component';
import { Subscription } from 'rxjs';

type optionType = 'agent'|'not-agent'| '';
@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.css']
})
export class TransactionComponent implements OnInit, OnDestroy {
  breadCrumb: any;
  loadingData: boolean = false;
  currentUser: any = null;
  transactions: transactionProp[] = [];
  selctType: optionType = '';
  showData: boolean = true;
  loadingZones: boolean = false;
  sub: Subscription;
  currentPage: number = 1;
  perPage: number = 10;
  agents: genderType[] = [
    {id: 0, name: 'Select Agent', value: ''}
  ];
  categories: genderType[] = [
    {id: 0, name: 'Select Category', value: ''}
  ];
  zones: genderType[] = [
    {id: 0, name: 'Select Zone', value: ''}
  ];
  currentDate = new Date(Date.now()).toISOString();
  constructor(
    private utilService: UtilService, 
    private superAdminService: SuperAdminService,
    private userService: UserService) {
    this.currentUser = this.utilService.getAuthUser();
  }

  filterForm = new FormGroup({
    from: new FormControl( '', Validators.required),
    to: new FormControl( '', Validators.required),
    agent_id: new FormControl( '', Validators.required),
    category: new FormControl('', Validators.required),
    zone_id: new FormControl({value: '', disabled: true}, Validators.required),
  })

  ngOnInit() {
    this.breadCrumb  = {
      name: 'Revenue report',
      parent: 'Reports',
      subLink: null
    };
    this.getTransactionReport({
      to: this.currentDate, from: '',
      zone_id: 0, category: '', agent_id: 0
    });
    this.getAgents();
    this.getCategories();

    this.sub = this.filterForm.get('category').valueChanges.subscribe((categoryValue: string) => {
      const zoneControl = this.filterForm.get('zone_id');
      if(categoryValue === ''){
        zoneControl.disable();
      }else{
        zoneControl.enable();
        this.getZones(categoryValue);
      }
      
    });
  }

  getTransactionReport(filters: transactionFilters) {
    this.loadingData = true;
    this.showData = false;
    this.userService.getTransactions(filters, this.currentPage, this.perPage)
      .subscribe((res) => {
        this.transactions = res;
        this.utilService.startDatatable('revenue-reports'); 
        this.loadingData = false;
        this.showData = true;
      }, error => {
        this.utilService.startDatatable('revenue-reports');
        this.loadingData = false;
        this.showData = true;
      });
  }

  getAgents(){
    this.superAdminService.getAllAgents().subscribe({
      next: (res)=>{
        const {data}=res.data;
        this.agents.push(...this.setOptionFields([], data, 'agent'));
      }
    })
  }

  getCategories(){
    this.userService.getCategories('').subscribe({
      next: (response)=>{
        const filter = response.filter((c)=> c.status.toLowerCase() === 'active');
        this.categories.push(...this.setOptionFields([], filter, 'not-agent'));
      }
    })
  }

  getZones(categoryId?: string){
    this.loadingZones = true;
    this.userService.getAllZones('', categoryId.toLowerCase()).subscribe({
      next: (response)=>{
        this.loadingZones = false;
        const zones = response.data;
        this.zones = this.setOptionFields( [], zones, 'not-agent');
      }
    })
  }

  setOptionFields(originalArray : genderType[], passedArray : any[], selectCase: optionType){
    const selectArray:genderType[] = passedArray.map((o)=>{
      return {
        id: o.id,
        name: selectCase === 'agent' ? o.full_name : o.name,
        value:  selectCase === 'agent' ? String(o.id) : o.name
      }
    })
    return [...originalArray, ...selectArray];
  }

  onFilterForm(){
    const from = this.getControlValue('from')
    const to = this.getControlValue('to');
    const agent_id = this.getControlValue('agent_id');
    const category = this.getControlValue('category');
    const zone_id = this.getControlValue('zone_id');
    const controls = {from, to, category, agent_id, zone_id};
    this.getTransactionReport(controls);
  }

  getControlValue(cntrl: string){
    const control = this.filterForm.get(cntrl)?.value?.toLowerCase();
    return control;
  }

  onFormValidate(){
    if( 
      this.getControlValue('to') > this.currentDate && this.getControlValue('from') > this.currentDate  ||
      this.getControlValue('to') !== '' && this.getControlValue('from') === '' || 
      this.getControlValue('to') === '' && this.getControlValue('from') !== '' ||
      this.getControlValue('from') > this.getControlValue('to') || this.getControlValue('to') > this.currentDate
     ){
      return true;
    }
    if(
      this.getControlValue('agent_id') !== '' || 
      this.getControlValue('from') !== '' || 
      this.getControlValue('to') !== '' ||
      this.getControlValue('category') !== '' || 
      this.getControlValue('zone_id') !== ''
    ) return false;
      return true;
  } 

  onFormReset(){
    this.filterForm.reset({
      agent_id: '',
      from: '',
      to: '',
      category: '',
      zone_id: ''
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
